<div class="header d-flex align-items-center justify-content-between px-3 px-lg-4 py-3">

  <div class="d-flex align-items-center">
    <a class="menu-toggle d-flex d-lg-none align-items-center clickable me-3" (click)="onToggleMenu()">
      <i class="bi bi-list fs-24 color-gray-950"></i>
    </a>
    <h1 class="fs-20 fw-800 color-gray-950 mb-0">{{titleKey|translate}}</h1>
  </div>

  <div class="d-none d-md-flex align-items-center">
    <ng-content></ng-content>
  </div>

</div>
